'use client';

import { useEffect } from 'react';

import { usePathname } from 'next/navigation';

const RB2B_ID = 'QOQRJHYLVK62';

export default function RB2BLoader() {
  const pathname = usePathname();

  useEffect(() => {
    const existing = document.getElementById('rb2b-script');
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.id = 'rb2b-script';
    script.src = `https://b2bjsstore.s3.us-west-2.amazonaws.com/b/${RB2B_ID}/${RB2B_ID}.js.gz`;
    script.async = true;
    document.body.appendChild(script);
  }, [pathname]);

  return null;
}
